webpackJsonp([267298091444410],{

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Collections = __webpack_require__(25);
	
	var _Collections2 = _interopRequireDefault(_Collections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Collections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'model'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'model'
	      ),
	      ' property is the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Model'
	      ),
	      ' class that resources should be converted to.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n      ...\n      model: Model,\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Most of the time, this property won\'t be needed, except when you need to transform the data for individual resources returned from the server.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, let\'s say you have an API endpoint located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:1337/tweets'
	      ),
	      ', that returns a collection of tweets that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      [\n        {\n          id: 1,\n          text: \'An old tweet\'\n        },\n        {\n          id: 2,\n          text: \'A new tweet\'\n        }\n      ]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you wanted to retrieve those tweets, you could create this collection:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Collection } from \'lore-models\';\n\n      const TweetCollection = Collection.extend({\n        urlRoot: \'http://localhost:1337/tweets\'\n      });\n\n      const tweets = new TweetCollection();\n\n      tweets.fetch();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the API call returns, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweet.models'
	      ),
	      ' would look like this (exactly mirroring the API response, but converted into Models):'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      [\n        new Model({\n          id: 1,\n          text: \'An old tweet\'\n        }),\n        new Model({\n          id: 2,\n          text: \'A new tweet\'\n        })\n      ]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'And if we converted that into a raw JSON object using ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.toJSON()'
	      ),
	      ' we would see this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      [\n        {\n          id: 1,\n          text: \'An old tweet\'\n        },\n        {\n          id: 2,\n          text: \'A new tweet\'\n        }\n      ]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'But sometimes you might want to transform that data, such as changing the name or value of a property, as mentioned in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' docs for Models (',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/models/properties/parse/' },
	        'link'
	      ),
	      ').'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For example, let\'s say we wanted to add a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'message'
	      ),
	      ' field to each model, to resolve a breaking API change. One way to do that would be to account for that in the collection\'s ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method like this:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can do that by defining a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Collection } from \'lore-models\';\n\n      const TweetCollection = Collection.extend({\n        urlRoot: \'http://localhost:1337/tweets\',\n\n        parse: function(response){\n          return response.data.map(function(datum){\n            datum.message = datum.text;\n            return datum;\n          });\n        }\n      });\n\n      const tweets = new TweetCollection();\n\n      tweets.fetch();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, we\'re iterating through the data provided by the API, and modifying the response to include a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'message'
	      ),
	      ' attribute that mirrors the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' attribute.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Alternatively, we could define that parse method in a custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Tweet'
	      ),
	      ' Model like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model, Collection } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        parse: function(response){\n          response.message = response.text;\n          return response;\n        }\n      });\n\n      const TweetCollection = Collection.extend({\n        model: Tweet,\n\n        urlRoot: \'http://localhost:1337/tweets\',\n\n        parse: function(response){\n          return response.data;\n        }\n      });\n\n      const tweets = new TweetCollection();\n\n      tweets.fetch();\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this code we\'ve created a custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Tweet'
	      ),
	      ' Model, and defined a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method that knows how to convert a single tweet resource into the format we need. Then, instead of including that logic in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'parse()'
	      ),
	      ' method for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'TweetCollection'
	      ),
	      ', we can leave it out.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'By defining the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'model'
	      ),
	      ' for the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'TweetCollection'
	      ),
	      ', the resources will automatically be cast to a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Tweet'
	      ),
	      ', and once the API call returns ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.models'
	      ),
	      ' will be composed like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      [\n        new Tweet({\n          id: 1,\n          text: \'An old tweet\'\n        }, { parse: true }),\n        new Tweet({\n          id: 2,\n          text: \'A new tweet\'\n        }, { parse: true })\n      ]\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'And calling ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tweets.toJSON()'
	      ),
	      ' would provide this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      [\n        {\n          id: 1,\n          text: \'An old tweet\',\n          message: \'An old tweet\'\n        },\n        {\n          id: 2,\n          text: \'A new tweet\',\n          message: \'A new tweet\'\n        }\n      ]\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collections-properties-model-js-40593a49bb2a12480ce3.js